// src/pages/login/LoginPage.tsx

import React, { useEffect } from "react";
import { Box, Typography, Avatar, Paper } from "@mui/material";

import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import AuthForm from "../../components/login/AuthForm";
import { Grid } from "@mui/joy";
import { Receipt } from "@mui/icons-material";
import { helpDeskNumber } from "../../utils/constants";

const LoginPage = () => {
  const leftColumnBgColor = "#3A5A78"; // A blue shade

  useEffect(() => {
    if (window.location.pathname === '/login') {
      document.body.classList.remove("Login");
      localStorage.clear();
    }
  }, []);

  useEffect(() => {

    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      const isAuthenticated = !!localStorage.getItem("token");
      if (!isAuthenticated) {

        window.location.href = "/login";
      } else {
        window.history.pushState(null, "", window.location.href);
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  return (
    // This Box acts as the main page container, centering the login card vertically and horizontally.
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      {/* <Box
        component="img"
        sx={{
          height: 70,
          position: "absolute",
          width: "100vw",
          minHeight: "100vh",
          objectFit: "cover",
          zIndex: 1,
        }}
        alt="background"
        src="bg-no-logo.png"
      /> */}
      <Paper
        elevation={6}
        sx={{
          // The main card container
          maxWidth: "750px",
          width: "100%",
          borderRadius: 2,
          zIndex: 3,
          overflow: "hidden", // Ensures children conform to border radius
        }}
      >
        <Grid container>
          {/* Left Column (Decorative) */}
          <Grid
            // item
            // On mobile (xs), it takes full width. On medium screens (md) and up, it takes 5/12 columns.
            xs={12}
            md={5}
            sx={{
              backgroundColor: '#a3b8c4',
              color: 'black',
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: { xs: 4, md: 5 }, // Responsive padding
              textAlign: "center",
            }}
            style={{ width: '50%', gap: "12px" }}
          >
            {/* <Avatar
              sx={{
                m: 1,
                bgcolor: "rgba(255,255,255,0.1)",
                width: 64,
                height: 64,
                mb: 2,
              }}
            >
              <Receipt sx={{ fontSize: 40 }} />
            </Avatar> */}
            <img
              src="/CWC1.png"
              alt="Central Warehousing Corporation logo"
              style={{

                height: "90px",
              }}
            />
            {/* <Box
              component="img"
              sx={{
                height: 100,
                marginBottom: 4,
              }}
              alt="Accenture Logo"
              src="acc-short-logo.png"
            /> */}
            <Typography component="h1" variant="h4" fontWeight="bold" gutterBottom>
              Bill Tracking System
            </Typography>
            <Typography variant="body1" component="p" sx={{ maxWidth: "400px", opacity: 0.9 }}>
              Secure access to your information and services.
            </Typography>
            <Typography variant="body1" component="p" sx={{ maxWidth: "400px", opacity: 0.9 }} style={{ color: 'white', fontWeight: 'bold' }}>
              For any assistance or queries, please contact the BTS helpdesk at <br /> {helpDeskNumber}.

            </Typography>
          </Grid>

          {/* Right Column (Login Form) */}
          <Grid
            // item
            // On mobile (xs), it takes full width. On medium screens (md) and up, it takes 7/12 columns.
            xs={12}
            md={7}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: { xs: 2, sm: 3, md: 4 },
            }}
            style={{ width: '50%' }}
          >
            <AuthForm />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default LoginPage;
